import { LeadSourceType } from "@/types/leadSource";

export const LEAD_SOURCES: LeadSourceType[] = [
  "Referral",
  "Corporate Website",
  "Meta Giveaway",
  "Meta Home",
  "Meta Auto",
  "Google PPC",
  "Google CTC",
  "Mortgage Broker",
  "3rd Party Website",
  "Direct Mail",
  "Call-In",
  "TikTok",
  "Social Media",
  "Other",
  "Email Campaign",
  "Friends & Family"
];